module.exports = __webpack_public_path__ + "img/25ne.f8debeec.svg";